import { render, staticRenderFns } from "./ShowBordero.vue?vue&type=template&id=28eac149&scoped=true&"
import script from "./ShowBordero.vue?vue&type=script&lang=js&"
export * from "./ShowBordero.vue?vue&type=script&lang=js&"
import style0 from "./ShowBordero.vue?vue&type=style&index=0&id=28eac149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eac149",
  null
  
)

export default component.exports